import fetch from "./fetch";
export var importData = function importData(data) {
  var opt = {
    url: '/api/cloudCabinet/importData',
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data: data,
    inData: false,
    loading: true
  };
  return fetch(opt);
};